/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiResponseGetDiscountRateResponse } from '../models/ApiResponseGetDiscountRateResponse';
import type { ApiResponseListGetInsuranceDiscountsResponse } from '../models/ApiResponseListGetInsuranceDiscountsResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class SpecialInsuranceContractControllerService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * 보험특약 최대 할인
   * @returns ApiResponseGetDiscountRateResponse OK
   * @throws ApiError
   */
  public getMaxDiscountRate(): CancelablePromise<ApiResponseGetDiscountRateResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/special-insurance-contract/max-discount-rate',
    });
  }
  /**
   * 보험특약 최대 할인
   * @returns ApiResponseGetDiscountRateResponse OK
   * @throws ApiError
   */
  public getMaxDiscountRate1(): CancelablePromise<ApiResponseGetDiscountRateResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/special-insurance-contract/max-discount-rate/',
    });
  }
  /**
   * 보험사 특약 정보 리스트
   * @returns ApiResponseListGetInsuranceDiscountsResponse OK
   * @throws ApiError
   */
  public getInsuranceDiscounts(): CancelablePromise<ApiResponseListGetInsuranceDiscountsResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/special-insurance-contract/insurance-discounts',
    });
  }
  /**
   * 보험사 특약 정보 리스트
   * @returns ApiResponseListGetInsuranceDiscountsResponse OK
   * @throws ApiError
   */
  public getInsuranceDiscounts1(): CancelablePromise<ApiResponseListGetInsuranceDiscountsResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/special-insurance-contract/insurance-discounts/',
    });
  }
}
